import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Footer from "./Footer";
import { NavigationHeader, NavigationFooter } from "@website-builder/ui/shared";
import { AElement } from "../../Elements";
import { LinkWithBadgeType, LinkType } from "./Header";
import { LinkSectionType, LinkWithLabelType } from "./Footer";

export const UserContext = createContext();

const HeaderFooter = ({
	header,
	footer,
	children,
	context,
	externalDependency,
}) => {
	const { apiBaseUrl, globalHostName, course_slug, isStaticBuild } = context;
	const { Link } = externalDependency;
	const [userDetails, setUserDetails] = useState({});

	return (
		<UserContext.Provider value={userDetails}>
			<div>
				{!!header &&
					(header.isB2Crebrand ? (
						<NavigationHeader
							{...header}
							globalHostName={globalHostName}
							apiBaseUrl={apiBaseUrl}
							courseSlug={course_slug}
							isStaticBuild={isStaticBuild}
							setUserDetailsProp={(userDetails) => setUserDetails(userDetails)}
							context={context}
						/>
					) : (
						<Header
							{...header}
							globalHostName={globalHostName}
							apiBaseUrl={apiBaseUrl}
							Link={Link}
							courseSlug={course_slug}
							isStaticBuild={isStaticBuild}
							setUserDetailsProp={(userDetails) => setUserDetails(userDetails)}
						/>
					))}
				<main>{children}</main>
				{!!footer &&
					(footer.isB2Crebrand ? (
						<NavigationFooter {...footer} context={context} isB2c={true} />
					) : (
						<Footer {...footer} Link={Link} context={context} />
					))}
			</div>
		</UserContext.Provider>
	);
};

HeaderFooter.propTypes = {
	header: PropTypes.shape({
		courses: PropTypes.arrayOf(LinkWithBadgeType),
		students: PropTypes.arrayOf(LinkWithBadgeType),
		howItWorks: PropTypes.arrayOf(LinkWithBadgeType),
		mentors: PropTypes.arrayOf(LinkWithBadgeType),
		logo: PropTypes.shape({
			imageUrl: PropTypes.string,
			altTag: PropTypes.string,
		}),
		exploreCareerpathsLink: LinkType,
		studentsLinkWithoutDropdown: PropTypes.bool,
	}),
	footer: PropTypes.shape({
		legalLinks: PropTypes.arrayOf(LinkWithLabelType),
		sectionOne: LinkSectionType,
		sectionTwo: LinkSectionType,
		sectionThree: LinkSectionType,
		sectionFour: LinkSectionType,
		enableIndiaSocialLinks: PropTypes.bool,
	}),
	children: PropTypes.array,
	context: PropTypes.shape({
		fullSlug: PropTypes.string,
		workshop_id: PropTypes.number,
		typeformLink: PropTypes.string,
		apiBaseUrl: PropTypes.string,
		globalHostName: PropTypes.string,
		isStaticBuild: PropTypes.bool,
	}),
	externalDependency: PropTypes.shape({
		Link: PropTypes.func.isRequired,
	}),
};

HeaderFooter.defaultProps = {
	header: null,
	footer: null,
	children: [],
	context: {
		fullSlug: "",
		workshop_id: 0,
		typeformLink: "",
		apiBaseUrl: "",
		globalHostName: "",
		isStaticBuild: true,
	},
	externalDependency: {
		Link: AElement,
	},
};
export default HeaderFooter;
